module.exports = __webpack_public_path__ + "media/images/members/tian_xia-3226b9c7878824f46d435d96b7a7226c.jpg";